import GraphQL from '@app/model/_common/service/GraphQL';
import { COUNTRY_FRAGMENT } from '@app/model/refdata/service/RefDataGraphqlFragments';
import { gql } from 'graphql-request';

export const STATIC_IMAGE_URL_QUERY: GraphQL = {
    name: "staticImageUrl",
    gql: gql`
        query staticImageUrl($filename:String!) {
            staticImageUrl(filename:$filename)
        }
    `
}

export const FIND_COUNTRIES_QUERY: GraphQL = {
    name: "findAllCountries",
    gql: gql`
        ${COUNTRY_FRAGMENT}
        query findAllCountries($sortBy: String) {
            findAllCountries(sortBy: $sortBy) {
                ...CountryFields
            }
        }
    `
}